(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.grouppractice');
    module.controller('GroupPracticeController', ['$scope', '$stateParams', GroupPracticeControllerFn]);

    function GroupPracticeControllerFn($scope, $stateParams) {
        var vm = this;

        $scope.$on('$viewContentLoaded', function () {
            App.initAjax(); // initialize core components
        });       
    }
})();
